import * as React from 'react';
export const IcBadminton = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M5.05 9.15a3 3 0 00.39 5.79 3 3 0 004.64 3.71 3 3 0 002.27 2.28 3 3 0 003.58-2.28L17.62 11l-4.55-4.52-8.02 2.67zm15-5.33a3 3 0 00-4.24.1l-1.2 1.28 4.24 4.24 1.32-1.38a3 3 0 00-.11-4.24h-.01z'
      fill='currentColor'
    />
  </svg>
);
